import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DefaultService } from '@psnb/psnb-api';
import { SharedService } from '../../datashared.service';
@Component({
  selector: 'psnb-mobile-selftestconfirm-dialog',
  templateUrl: './selftestconfirm-dialog.component.html',
  styleUrls: ['./selftestconfirm-dialog.component.scss']
})
export class SelftestconfirmDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<SelftestconfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data,private matsnackbar: MatSnackBar,
    private powerSupplySvc: DefaultService,
    private sharedService: SharedService) { }

  ngOnInit(): void {
  }
  spinner = false;
  error:Boolean = false;
  action:String = this.data.action;;

  operationsReload(){
    window.location.reload();
  }
  operations() {
    this.error = false;
    this.spinner = true;
    if(this.action === 'Self Test Start') {
       this.powerSupplySvc.selfTestStart(this.data.ip, this.data.macAddress,this.data.powerSupplyId).subscribe(result => {
         if(result.success === true) {
          this.spinner = false;
           this.dialogRef.close(result.success);
           this.matsnackbar.open('Self Start Completed successfully.', 'dismiss', {
            duration: 2000
          });
          //this.operationsReload();
          this.sharedService.setDataTelemetryReload('reload');
        } else{
          this.spinner = false;
          this.matsnackbar.open('Self Start not Completed successfully. Please try again.', 'error', {
            duration: 4000
          });
          //this.operationsReload();
          this.sharedService.setDataTelemetryReload('reload');
          this.dialogRef.close();
        }
      },err => {
        this.spinner = false;
          this.matsnackbar.open('Self Start not Completed successfully. Please try again.', 'error', {
            duration: 4000
          });
          this.dialogRef.close();
      })
    } else if(this.action === 'Self Test Stop') {
      this.powerSupplySvc.selfTestStop(this.data.ip, this.data.macAddress,this.data.powerSupplyId).subscribe(result => {
        if(result.success === true) {
         this.spinner = false;
          this.dialogRef.close(result.success);
          this.matsnackbar.open('Self Stop Completed successfully.', 'dismiss', {
           duration: 2000
         });
         //this.operationsReload();
         this.sharedService.setDataTelemetryReload('reload');
       } else{
         this.spinner = false;
         this.matsnackbar.open('Self Stop not Completed successfully. Please try again.', 'error', {
           duration: 4000
         });
         //this.operationsReload();
         this.sharedService.setDataTelemetryReload('reload');
         this.dialogRef.close();
       }
     },err => {
      this.spinner = false;
        this.matsnackbar.open('Self Start not Completed successfully. Please try again.', 'error', {
          duration: 4000
        });
        this.dialogRef.close();
    })
   }
   /*US2481218 : HMS Reset button remove no longer needed instead add CM Kickstart
   else if(this.action === 'HMS Reset') {
    this.powerSupplySvc.hmsReset(this.data.ip, this.data.macAddress,this.data.powerSupplyId).subscribe(result => {
      if(result.success === true) {
       this.spinner = false;
        this.dialogRef.close(result.success);
        this.matsnackbar.open('HMS Reset Completed successfully.', 'dismiss', {
         duration: 2000
       });
       //this.operationsReload();
       this.sharedService.setDataTelemetryReload('reload');
     } else{
       this.spinner = false;
       this.matsnackbar.open('HMS Reset not Completed successfully. Please try again.', 'error', {
         duration: 4000
       });
       this.dialogRef.close(result.success);
       //this.operationsReload();
       this.sharedService.setDataTelemetryReload('reload');
     }
   },err => {
    this.spinner = false;
      this.matsnackbar.open('Self Start not Completed successfully. Please try again.', 'error', {
        duration: 4000
      });
      this.dialogRef.close();
  })
  }*/
  else if (this.action === 'CM Kick Start') {
    this.powerSupplySvc.performCMKickStart(this.data.ip, this.data.cmts, this.data.macAddress, this.data.powerSupplyId).subscribe(result => {
      if (result.success === true) {
        this.spinner = false;
        this.dialogRef.close(result.success);
        this.matsnackbar.open(result.message, 'dismiss', {
         duration: 2000
       });
       //this.operationsReload();
       this.sharedService.setDataTelemetryReload('reload');
      } else {
        this.spinner = false;
        this.matsnackbar.open(result.message + ' Please try again.', 'error', {
          duration: 4000
        });
        this.dialogRef.close(result.success);
        //this.operationsReload();
       this.sharedService.setDataTelemetryReload('reload');
      }
    }, err => {
      this.spinner = false;
      this.matsnackbar.open('Exception while performing CM Kick Start. Please try again.', 'error', {
        duration: 4000
      });
      this.dialogRef.close();
    })
  }
  else if (this.action === 'RMODE OPERATION') {
   this.powerSupplySvc.setRmodeByMac(this.data.ip, this.data.macAddress, this.data.powerSupplyId).subscribe(result => {
     if (result.success === true) {
       this.spinner = false;
       this.dialogRef.close(result.success);
       this.matsnackbar.open('RMODE OPERATION Completed successfully.', 'dismiss', {
         duration: 2000
       });
       this.sharedService.setDataTelemetryReload('reload');
     } else {
       this.spinner = false;
       this.matsnackbar.open('RMODE OPERATION not Completed successfully. Please try again.', 'error', {
         duration: 4000
       });
       this.sharedService.setDataTelemetryReload('reload');
       }
     }, err => {
       this.spinner = false;
       this.matsnackbar.open('RMODE OPERATION not Completed successfully. Please try again.', 'error', {
         duration: 4000
       });
     })
  } else if(this.action === 'CM Reset') {
  this.powerSupplySvc.docsisReset(this.data.ip, this.data.macAddress,this.data.powerSupplyId).subscribe(result => {
    if(result.success === true) {
     this.spinner = false;
      this.dialogRef.close(result.success);
      this.matsnackbar.open('CM Reset Completed successfully.', 'dismiss', {
       duration: 2000
     });
     //this.operationsReload();
     this.sharedService.setDataTelemetryReload('reload');
   } else{
     this.spinner = false;
     this.matsnackbar.open('CM Reset not Completed successfully. Please try again.', 'error', {
       duration: 4000
     });
     this.dialogRef.close(result.success);
     //this.operationsReload();
     this.sharedService.setDataTelemetryReload('reload');
   }
 },err => {
  this.spinner = false;
    this.matsnackbar.open('Self Start not Completed successfully. Please try again.', 'error', {
      duration: 4000
    });
    this.dialogRef.close();
})
}
  }


}
